export class ListGraphsFilterConditions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "IdFilters",
            "format": ""
        },
        {
            "name": "title",
            "baseName": "title",
            "type": "StringFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListGraphsFilterConditions.attributeTypeMap;
    }
    constructor() {
    }
}
